import { DISPLAY_CURRENCIES, ICON_TYPES } from "@shared/common/constants";
import { useSelector } from "react-redux";
import React, { CSSProperties, ReactNode } from "react";
import { DisplayCurrency } from "@shared/types";
import Flex from "common/Boxes/Flex";
import IconWithFallback, {
  IconWithFallbackProps,
} from "Global/IconWithFallback";
import { selectDisplayCurrency } from "@shared/slices/common.slice";
import { BTC } from "common/Icons/Icons";

export interface TextWithIconProps extends IconWithFallbackProps {
  text?: ReactNode;
  justify?: string;
  currency?: DisplayCurrency | null;
  style?: CSSProperties;
  textStyle?: CSSProperties;
  pxIconSize?: number;
}

const TextWithIcon = ({
  text,
  iconLink,
  iconType = ICON_TYPES.DISPLAY_CURRENCY,
  iconStyle,
  iconSize,
  coinOrExchangeName,
  justify,
  currency,
  style,
  textStyle,
  pxIconSize,
}: TextWithIconProps) => {
  let displayCurrency = useSelector(selectDisplayCurrency);
  if (currency) displayCurrency = currency;

  let iconElement: ReactNode;
  if (iconType === ICON_TYPES.DISPLAY_CURRENCY && !iconLink) {
    iconElement =
      displayCurrency === DISPLAY_CURRENCIES.BTC ? (
        <BTC style={{ marginRight: 2, ...iconStyle }} />
      ) : (
        <span style={iconStyle}>$</span>
      );
  } else if (
    iconType === ICON_TYPES.COIN ||
    iconType === ICON_TYPES.EXCHANGE ||
    iconLink
  ) {
    iconElement = (
      <IconWithFallback
        coinOrExchangeName={coinOrExchangeName}
        iconType={iconType}
        iconStyle={
          iconStyle || {
            marginRight: 6,
          }
        }
        iconSize={iconSize}
        pxIconSize={pxIconSize}
        iconLink={iconLink}
      />
    );
  }

  return (
    <Flex
      $alignItems={"center"}
      $justifyContent={justify}
      $inline={true}
      style={style}
    >
      {iconElement}
      <span
        style={{
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          ...textStyle,
        }}
      >
        {text}
      </span>
    </Flex>
  );
};

export default TextWithIcon;
